import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";

@Injectable()
export class DataScreenService {

  constructor(private http: HttpCommonService,
              private httpClient: HttpClient) {
  }

  /**
   * 查询企业总数
   * @returns {Observable<any>}
   */
  getEnterpSize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getEnterpriseSize');
  }

  /**
   * 查询关注的企业数
   * @returns {Observable<any>}
   */
  getAttentionEnterpSize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getAttentionEnterPriseSize');
  }

  /**
   * 查询风险失信数
   * @returns {Observable<any>}
   */
  getRiskSize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getRiskSize');
  }

  /**
   * 查询本月新增
   * @returns {Observable<any>}
   */
  getMonthNewRiskSize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getMonthNewRiskSize');
  }

  /**
   * 本月查询量
   * @returns {Observable<any>}
   */
  getMonthRecordQuerySize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getMonthRecordQuerySize');
  }

  /**
   * 本月推送量
   * @returns {Observable<any>}
   */
  getMonthPushSize(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getMonthPushSize');
  }

  /**
   * 关注企业地区分布统计
   * @returns {Observable<any>}
   */
  getAreaStatistics(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getAreaStatistics');
  }

  /**
   * 关注企业地图分布
   * @returns {Observable<any>}
   */
  getEnterpMap(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getEnterpriseMap');
  }

  /**
   * 关注企业行业分布统计
   * @returns {Observable<any>}
   */
  getInsturyStatistics(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/customerScreen/getInsturyStatistics');
  }

  /**
   * 历史查询
   * @returns {Observable<any>}
   */
  getHistorySearch(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/search/getSearchHistory');
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/data-screen.service.ts